import { render } from "./NavRoot.vue?vue&type=template&id=51540ab0&scoped=true&ts=true"
import script from "./NavRoot.vue?vue&type=script&lang=ts"
export * from "./NavRoot.vue?vue&type=script&lang=ts"

import "./NavRoot.vue?vue&type=style&index=0&id=51540ab0&scoped=true&lang=css"

import exportComponent from "G:\\01.Progetti\\GitHub\\SCIENZE_NATURALI_app\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-51540ab0"]])

export default __exports__